module.exports = __webpack_public_path__ + "media/images/logo_450x171-0078b0238d5770755501fe1b37653cfb.png";